/** @jsx jsx */
import type { PropsWithChildren } from 'react';
import React from 'react';
import { jsx } from '@balance-web/core';

import { ReckonBalanceCore } from '@reckon-web/reckon-balance-core';
import { UniversalTanstackRouterLink } from '@reckon-web/universal-tanstack-router-link';

import { ClipboardProvider } from '../../common/ClipboardButton';

/**
 * Wraps up all the various Providers that are required by our Balance DS
 *
 * Configure the app theme here.
 */
export function BalanceProvider({ children }: PropsWithChildren<{}>) {
  return (
    <ReckonBalanceCore
      linkComponent={UniversalTanstackRouterLink}
      themeMode="light"
    >
      <ClipboardProvider>{children}</ClipboardProvider>
    </ReckonBalanceCore>
  );
}
